const listRef = document.querySelector(".store__product-list");
const allBtnRef = document.querySelectorAll(".store__btn");
import products from "./products.json";
import createItems from "./js/createItems";
import debounce from 'debounce';

listRef.innerHTML = createItems(products);
allBtnRef.forEach(btn=>{
    btn.addEventListener("click",(event)=>{
        const type = event.target.dataset.type
        switch (type) {
            case "fruits":
                const onlyFruits = products.filter(item=>item.category === "Фрукти");
                listRef.innerHTML = createItems(onlyFruits);
                break;
            case "vegetables":
                const onlyVeg = products.filter(item=>item.category === "Овочі");
                listRef.innerHTML = createItems(onlyVeg);
                break;
            case "bakery":
                const onlyBakery = products.filter(item=>item.category === "Випічка");
                listRef.innerHTML = createItems(onlyBakery);
                break;
            case "milk":
                const onlyMilk = products.filter(item=>item.category === "Молочні продукти");
                listRef.innerHTML = createItems(onlyMilk);
                break;
            case "meat":
                const onlyMeat = products.filter(item=>item.category === "Овочі");
                listRef.innerHTML = createItems(onlyMeat);
                break;
            case "price":
                const sortByPrice = [...products].sort((a,b)=>a.price-b.price)
                listRef.innerHTML = createItems(sortByPrice);
                break;
            case "back":
                listRef.innerHTML = createItems(products);
                break;
        }

    })
});

const allPlusRef = document.querySelectorAll(".store__btn-plus");
const counter = document.querySelector(".position")
console.log(allPlusRef);

let count = 0

allPlusRef.forEach(btn=>{
    btn.addEventListener("click",_.debounce(()=>{
        count+=1
        counter.textContent = count;
    },300))
})

